module.exports = __webpack_public_path__ + "278ab0e35b2f630da2aa364ded6faac3.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/termine/22-08-11RasgaRasga-mini.jpg
// module id = 826
// module chunks = 0